import React, {useEffect, useState, useRef} from "react";
import {COMMUNITY_ACTION_TYPES} from "./communityReducer";
import editIcon from "../../../../public/images/edit_white.svg";
import deleteIcon from "../../../../public/images/delete_white.svg";
import copyLinkIcon from "../../../../public/images/copyLinkIcon.svg";
import {Provider, useDispatch, useSelector} from "react-redux";
import styles from "../../css/community-detailed.module.css";
import style from "../../css/community.module.css";
import ModalDialog from "../../../shared/components/ModalDialog";
import {getDate} from "../../../app/dashboard/utils/get-date";
import {getColor} from "../../../shared/utils/getColor";
import {useCommunityDelete} from "./CommunityCustomHooks/useCommunityDelete";
import PopUpContainer from "../../../shared/components/PopUpContainer";
import AskEditQuestionPopUp from "./CommunityPopUps/AskEditQuestionPopUp";
import {PAGE_HASH_LOCATION} from "../../../app/utils/pages";
import editIconMobile from "../../../../public/images/icons/community-edit-icon.svg";
import deleteIconMobile from "../../../../public/images/icons/community-delete-icon.svg";
import copylink from "../../../../public/images/icons/CopyLinkIcon.svg";
import searchBlue from "../../../../public/images/search-blue.svg"
import ActionButtonContainer from "../../../shared/containers/ActionButtonContainer";
import newAdminStore from "../../../admin/store/newAdminStore";
import SearchContainer from "../../../admin/containers/SearchContainer";
import {isMobileOnly} from "react-device-detect";
import {communityAllQuestions, deleteQuestion} from "../../../shared/utils/sash-v2-api";
import Paginator from "../../../shared/components/Paginator";


const CommunityAllThreads = (props) => {
    const dispatch = useDispatch();
    const [editQuestionPopUp, setEditQuestionPopUp] = useState(false);
    const [threadToEdit, setThreadToEdit] = useState(null);
    const allThreads = useSelector((state) => state.communityReducer.allThreads);
    const trending = useSelector((state) => state.communityReducer.trending);
    const userQuestions = useSelector((state) => state.communityReducer.userQuestions);
    const userAnswers = useSelector((state) => state.communityReducer.userAnswers);
    const allQuestionsCount = useSelector((state) => state.communityReducer.communityTotalQuestionsCount);
    const userId = useSelector((state) => state.userReducer.userId);
    const [searchTerm, setSearchTerm] = useState("");
    const [askPopUp, setAskPopUp] = useState(false);
    const [copiedQuestionId, setCopiedQuestionId] = useState(null);
    const [copyStatus, setCopyStatus] = useState({});
    const [pageIndex, setPageIndex] = useState(0);
    const [cachedData, setCachedData] = useState({});
    const isInitialMount = useRef(true);
    const {deletePopUp, threadToDelete, handleCommunityDeletePopUp, handleCommunityDeletePopUpClose} = useCommunityDelete();
    const questions_per_page = 50

    const handleSuccess = (response, index) => {
        const newData = searchTerm || props.searchTerm ? response.searchQuestions : response.all_questions;
        dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_ALL_THREADS,
            payload: newData,
        });

        dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_TOTAL_QUESTIONS_COUNT,
            payload: response.total_question_count,
        });
        dispatch({
            type: COMMUNITY_ACTION_TYPES.SET_TOTAL_ANSWER_COUNT,
            payload: response.total_answers_count,
        });

        // Cache the fetched data
        setCachedData(prevData => ({
            ...prevData,
            [index]: newData,
        }));

    };

    const handleFailure = (error) => {
        console.error("Error:", error);
    };

    const allQuestionsData = (index) => {
        if (cachedData[index]) {
            dispatch({
                type: COMMUNITY_ACTION_TYPES.SET_ALL_THREADS,
                payload: cachedData[index],
            });
            return;
        }

        communityAllQuestions((response) => handleSuccess(response, index), handleFailure, props.searchTerm || searchTerm ? 100 : questions_per_page, index, searchTerm);
    };

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            allQuestionsData(pageIndex);
            return;
        }
        allQuestionsData(pageIndex);
    }, [pageIndex, searchTerm, props.searchTerm]);

    const handlePageChange = (pageIndex) => {
        setPageIndex(pageIndex.selected)
    }


    const handleTextChange = (text) => {
        setSearchTerm(text);
    };


    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.type === 'click') {
            if (searchTerm || props.searchTerm) {
                allQuestionsData();
            }
        }
    }
    const handleEditQuestionPopUp = (thread) => {
        setThreadToEdit(thread);
        setEditQuestionPopUp(true);
    };


    const handleDeleteThread = () => {
        if (threadToDelete) {
            const questionId = threadToDelete;
            const successFunction = () => {
                const updatedThreads = allThreads.filter(
                    (thread) => thread._id !== questionId
                );
                const updatedUserQuestions = userQuestions.filter(
                    (thread) => thread._id !== questionId
                );
                const updatedTrendingQuestions = trending.filter(
                    (thread) => thread._id !== questionId
                );
                const updatedMyAnswersQuestions = userAnswers.filter(
                    (item) => (item.question?._id !== questionId && item?._id !== questionId)
                );

                dispatch({
                    type: COMMUNITY_ACTION_TYPES.SET_ALL_THREADS,
                    payload: updatedThreads,
                });
                dispatch({
                    type: COMMUNITY_ACTION_TYPES.SET_TOTAL_QUESTIONS_COUNT,
                    payload: allQuestionsCount - 1,
                });
                dispatch({
                    type: COMMUNITY_ACTION_TYPES.SET_USER_QUESTIONS,
                    payload: updatedUserQuestions,
                });
                dispatch({
                    type: COMMUNITY_ACTION_TYPES.SET_TRENDING,
                    payload: updatedTrendingQuestions,
                });
                dispatch({
                    type: COMMUNITY_ACTION_TYPES.SET_USER_ANSWERS,
                    payload: updatedMyAnswersQuestions,
                });
                handleCommunityDeletePopUpClose();
            };

            const failureFunction = (error) => {
                console.error("Failed to delete thread:", error);
                alert("Something went wrong !")
                handleCommunityDeletePopUpClose();
            };

            deleteQuestion(questionId, successFunction, failureFunction);
        } else {
            handleCommunityDeletePopUpClose();
        }
    };

    const closePopUp = () => {
        setEditQuestionPopUp(false);
        setThreadToEdit(null);
    };

    const closeAddPopUp = () => {
        setAskPopUp(false);
    }

    const handleAddQuestion = () => {
        if (!userId) {
            localStorage.setItem("isCommunity", true);
            window.location = "/app" + PAGE_HASH_LOCATION.login;
        } else {
            setAskPopUp(true);
        }
    };

    const handleThreadClick = (threadId) => {
        window.location.href = window.location.origin + PAGE_HASH_LOCATION.community + `/?id=${threadId}`;
    };

    const handleCopyLink = (threadId) => {
        const link = `${window.location.origin}/#community/?id=${threadId}`;
        navigator.clipboard
            .writeText(link)
            .then(() => {
                setCopiedQuestionId(threadId);
                setCopyStatus((prevState) => ({
                    ...prevState,
                    [threadId]: "Link Copied",
                }));

                setTimeout(() => {
                    setCopiedQuestionId(null);
                    setCopyStatus((prevState) => ({
                        ...prevState,
                        [threadId]: "Copy Link",
                    }));
                }, 2000);
            })
            .catch((error) => {
                console.error("Failed to copy text: ", error);
            });
    };


    return (
        <>
            {
                !isMobileOnly ?
                    <>
                        <div
                            style={{height: "82.6vh", overflow: "scroll", gap: "10px"}}
                            className={styles.threadsContainer}>
                            {allThreads?.length === 0 ? (
                                <div className={styles.noResults}>
                                    <p>No results found</p>
                                </div>
                            ) : (
                                <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                                    {allThreads?.map((thread) => (
                                        <div style={{
                                            backgroundColor: "white",
                                            padding: "5px 15px",
                                            borderRadius: "15px"
                                        }}
                                             key={thread._id}>
                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                <div className={styles.leftHeader}>
                                                    {userId !== thread.user_id ? (
                                                        <div className={styles.communityAvatar}
                                                             style={{backgroundColor: getColor(thread?.user_id[0])}}>
                                                            <span>{thread.user_id[0].toUpperCase()}</span>
                                                        </div>
                                                    ) : (
                                                        <div className={styles.userInfo}>
                                                            <div className={styles.dateContainer}>
                                                                <p className={styles.communityDate}>{getDate(thread.created_at)}</p>
                                                                <div className={styles.editDeleteButtons}>
                                                                    <div onClick={() => handleEditQuestionPopUp(thread)}
                                                                         className={styles.editButton}>
                                                                        <div style={{display: "flex"}}>
                                                                            <img style={{marginRight: "2px"}}
                                                                                 height={12}
                                                                                 src={editIcon} alt="edit"/>
                                                                            <span>Edit</span>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        onClick={() => handleCommunityDeletePopUp(null, thread._id)}
                                                                        className={styles.deleteButton}>
                                                                        <div style={{display: "flex"}}>
                                                                            <img height={12} src={deleteIcon}
                                                                                 alt="delete"/>
                                                                            <span>Delete</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {userId !== thread.user_id && (
                                                        <div className={styles.userInfo}>
                                                            <p style={{margin: "5px 0"}} className={styles.userName}>
                                                                {thread.user_id.split("@")[0]}
                                                            </p>
                                                            <p style={{margin: "5px 0"}}
                                                               className={styles.communityDate}>
                                                                {getDate(thread.created_at)}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
                                                    <div className={styles.answerCount}>
                                                        {thread.answer_count}{" "}
                                                        {thread.answer_count === 1 ? "Answer" : "Answers"}
                                                    </div>
                                                    <div style={{backgroundColor: "#F5F5F5"}}
                                                         className={styles.copyLinkButton}
                                                         onClick={() => handleCopyLink(thread._id)}>
                                                        <img width={15} src={copyLinkIcon} alt="copy"/>
                                                        {copyStatus[thread._id] || "Copy Link"}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{cursor: "pointer"}}
                                                 onClick={() => handleThreadClick(thread._id)}>
                                                <p style={{color: "#004BA0", fontWeight: "bold"}}
                                                   className={styles.questionTitle}>{thread.title}</p>
                                                <div>
                                                    {thread.description.split("\n").length > 0 ? (
                                                        thread.description.split("\n").map((line, index) => (
                                                            <p style={{fontSize: "14px"}} key={index}>{line}</p>
                                                        ))
                                                    ) : (
                                                        <p style={{fontSize: "14px"}}>{thread.description}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {deletePopUp && (
                                <ModalDialog
                                    header={"DELETE"}
                                    body={
                                        <p style={{textAlign: "center", margin: "0"}}>
                                            Are you sure you want to delete your Question? <br/> Deleting the
                                            question will delete all the answers <br/> associated with it.
                                        </p>
                                    }
                                    buttons={[
                                        {
                                            text: "CANCEL",
                                            action: handleCommunityDeletePopUpClose,
                                        },
                                        {
                                            text: "DELETE",
                                            action: handleDeleteThread,
                                        },
                                    ]}
                                />
                            )}

                            {editQuestionPopUp && (
                                <PopUpContainer>
                                    <AskEditQuestionPopUp
                                        selectedThread={threadToEdit}
                                        onClose={closePopUp}
                                    />
                                </PopUpContainer>
                            )}
                        </div>
                        <div style={{position: "absolute", bottom: '0'}}>
                            <Paginator handlePageChange={handlePageChange} initialPage={0}
                                       totalPageCount={Math.abs(allQuestionsCount / questions_per_page)}
                                       containerClassName={'community-page'}
                            />
                        </div>
                    </>
                    :
                    <>
                        <div className={style.communityContainer}>
                            <div className={style.communityHeader}>
                                <h1 style={{fontSize: "27px", fontWeight: "700", marginTop: "9px"}}>Community</h1>
                                <ActionButtonContainer
                                    buttonText="+ Ask Question"
                                    fontSize="16px"
                                    buttonWidth="160px"
                                    handleClick={handleAddQuestion}
                                />
                            </div>

                            <div style={{display: 'flex', alignItems: 'center', marginTop: '-20px'}}>
                                <div style={{
                                    backgroundColor: "white",
                                    width: "95%",
                                    borderRadius: "20px",
                                    marginTop: "12px"
                                }}>
                                    <Provider store={newAdminStore}>
                                        <SearchContainer
                                            handleTextChange={handleTextChange}
                                            handleKeyDown={handleKeyDown}
                                            width={'300px'}
                                            padding={"10px"}
                                            height={"30px"}
                                            marginTop={"-9px"}
                                        />
                                    </Provider>
                                </div>
                                <div style={{marginTop: '10px'}}>
                                    <img onClick={handleKeyDown} src={searchBlue} height={40} alt={'search'}/>
                                </div>
                            </div>


                            <div className={style.questionsList}>
                                {allThreads?.length === 0 &&
                                    <h3 style={{minHeight: '100vh'}}>No Questions Found</h3>}
                                {allThreads?.map((question) => {
                                    return (
                                        <div
                                            key={question._id}
                                            className={`${style.questionCard} ${question.user_id === userId ? style.currentUser : style.defaultUser}`}
                                            onClick={() => handleThreadClick(question._id)}
                                        >
                                            <div className={style.cardHeader}>
                                                <div className={style.userDetails}>
                                                    {question.user_id !== userId && (
                                                        <>
                                                            <div
                                                                className={style.communityAvatar}
                                                                style={{backgroundColor: getColor(question?.user_id[0])}}
                                                            >
                                                                {question.user_id[0].toUpperCase()}
                                                            </div>
                                                            <div className={style.userInfo}>
                        <span className={style.userName}>
                          {question.user_id.split("@")[0]}
                        </span>
                                                                <span
                                                                    className={style.createdDate}>{getDate(question.created_at)}</span>
                                                            </div>
                                                        </>
                                                    )}
                                                    {question.user_id === userId && (
                                                        <span
                                                            className={style.createdDate}>{getDate(question.created_at)}</span>
                                                    )}
                                                </div>
                                                {question.user_id === userId && (
                                                    <div className={style.actionButtons}>
                                                        <img
                                                            src={editIconMobile}
                                                            alt="Edit"
                                                            className={style.actionIcon}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleEditQuestionPopUp(question);
                                                            }}
                                                        />
                                                        <img
                                                            src={deleteIconMobile}
                                                            alt="Delete"
                                                            className={style.actionIcon}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleCommunityDeletePopUp(null, question._id)
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            <div className={style.answersSection}>
                <span className={style.answersCount}>
                  {question.answer_count || 0}{" "}
                    {question.answer_count === 1 ? "Answer" : "Answers"}
                </span>
                                                {copiedQuestionId === question._id ? (
                                                    <span>Copied!</span>
                                                ) : (
                                                    <img
                                                        src={copylink}
                                                        alt="Copy link"
                                                        className={style.copyLinkIcon}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleCopyLink(question._id);
                                                        }}
                                                    />
                                                )}
                                            </div>
                                            <h2 className={style.questionTitle}>{question.title}</h2>
                                            <p className={style.description}>{question.description}</p>
                                        </div>
                                    );
                                })}
                            </div>

                            {askPopUp && (
                                <PopUpContainer>
                                    <AskEditQuestionPopUp
                                        selectedThread={null}
                                        onClose={closeAddPopUp}/>
                                </PopUpContainer>
                            )}

                            {editQuestionPopUp && (
                                <PopUpContainer>
                                    <AskEditQuestionPopUp
                                        selectedThread={threadToEdit}
                                        onClose={closePopUp}
                                    />
                                </PopUpContainer>
                            )}

                            {deletePopUp && (
                                <ModalDialog
                                    header="Delete"
                                    body={
                                        <p style={{textAlign: 'center'}}>
                                            Are you sure you want to delete this question? <br/>
                                            Deleting the question will delete all the answers <br/>
                                            associated with it.
                                        </p>
                                    }
                                    buttons={[
                                        {text: "Cancel", action: handleCommunityDeletePopUpClose},
                                        {text: "Delete", action: handleDeleteThread},
                                    ]}
                                    onClose={handleCommunityDeletePopUpClose}
                                />
                            )}
                        </div>
                        <div>
                            <Paginator handlePageChange={handlePageChange} initialPage={0}
                                       totalPageCount={Math.abs(allQuestionsCount / questions_per_page)}
                                       containerClassName={'community-page'}
                            />
                        </div>
                    </>
            }
        </>

    );
};

export default CommunityAllThreads;